module.exports = __webpack_public_path__ + "img/bi_tit.d2dcbbe4.png";